<template>
    <div class="set-component">
        <div class="set-header">通用设置</div>
        <div class="set-body">
            <el-form label-width="120px" size="small">
                <el-form-item label="字体大小">
                    <el-select v-model="setting.fontSize">
                        <el-option label="小" value="small" />
                        <el-option label="中" value="medium" />
                        <el-option label="大" value="large" />
                        <el-option label="默认" value="default" />
                    </el-select>
                </el-form-item>
                <el-form-item label="语言">
                    <el-select v-model="setting.language">
                        <el-option label="简体中文" value="zh-CN" />
                        <el-option label="繁体中文" value="zh-TW" />
                        <el-option label="English" value="en" />
                    </el-select>
                </el-form-item>
                <el-form-item label="自动清理缓存">
                    <el-switch v-model="setting.autoClearCache" :active-value="1" :inactive-value="0" />
                </el-form-item>
                <el-form-item label="缓存大小">
                    <span>{{ setting.cacheSize }} MB</span>
                    <el-button size="mini" type="text" @click="clearCache" style="margin-left: 12px;">清理缓存</el-button>
                </el-form-item>
                <el-form-item label="当前版本">
                    <span>{{ setting.appVersion }}</span>
                </el-form-item>
            </el-form>
            <el-button type="primary" size="small" :loading="saveLoading" @click="handleSave">保存</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GeneralSetting',
    data() {
        return {
            setting: {
                fontSize: 'default',
                language: 'zh-CN',
                autoClearCache: 0,
                cacheSize: 0,
                lastClearTime: null,
                appVersion: '1.0.0'
            },
            saveLoading: false
        };
    },
    mounted() {
        this.loadGeneralSetting();
    },
    methods: {
        getUserId() {
            const user = JSON.parse(localStorage.getItem('userInfo'));
            return user ? (user.userId || user.id) : null;
        },
        async loadGeneralSetting() {
            try {
                const userId = this.getUserId();
                if (userId) {
                    const res = await this.$axios.get('/api/user/general/get', { params: { userId } });
                    if (res.data && res.data.code === 200) {
                        const data = res.data.data;
                        if (data) {
                            this.setting = { ...this.setting, ...data };
                        }
                    }
                }
            } catch (e) {
                console.error('获取通用设置失败', e);
            }
        },
        async handleSave() {
            this.saveLoading = true;
            try {
                const userId = this.getUserId();
                const res = await this.$axios.post('/api/user/general/update', {
                    userId,
                    fontSize: this.setting.fontSize,
                    language: this.setting.language,
                    autoClearCache: this.setting.autoClearCache
                });
                if (res.data && res.data.code === 200) {
                    this.$message.success('保存成功');
                }
            } catch (e) {
                this.$message.error('保存失败');
            } finally {
                this.saveLoading = false;
            }
        },
        async clearCache() {
            try {
                const userId = this.getUserId();
                const res = await this.$axios.post('/api/user/general/clear-cache', null, { params: { userId } });
                if (res.data && res.data.code === 200) {
                    this.$message.success('缓存清理成功');
                    this.loadGeneralSetting();
                }
            } catch (e) {
                this.$message.error('清理失败');
            }
        }
    }
};
</script>

<style scoped>
.set-component { background: var(--card-background); border-radius: 12px; border: 1px solid var(--border-color-lighter); }
.set-header { padding: 18px 24px; font-size: 16px; font-weight: 600; color: var(--text-color); border-bottom: 1px solid var(--border-color-lighter); }
.set-body { padding: 24px; }
</style>
